import React, { useState, useEffect } from 'react';
import {Select} from 'antd';
import './index.css';


const PaginationComponent = ({ pagination: paginationProps, onChange ,isImage}) => {
  const { Option } = Select;
  const pageSizeOptionsCommon = [
    { value: 10, label: '10/page' },
    { value: 20, label: '20/page' },
    { value: 50, label: '50/page' },
    { value: 100, label: '100/page' },
  ];
  const pageSizeOptionsImage = [
    { value: 10, label: '10/page' },
    { value: 20, label: '20/page' },
    { value: 30, label: '30/page' },
  ];

  const pageSizeOptions = isImage?pageSizeOptionsImage:pageSizeOptionsCommon;

  const [pageInputValue, setPageInputValue] = useState(paginationProps.current?.toString() || '1');

  useEffect(() => {
    setPageInputValue(paginationProps.current?.toString() || '1');
  }, [paginationProps]);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    if (/^\d*$/.test(inputValue) || inputValue === '') {
      setPageInputValue(inputValue);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      const inputValue = e.target.value;
      if (inputValue === '') {
        return;
      }
      
      const pageNum = Number(inputValue);
      if (!isNaN(pageNum) && pageNum > 0) {
        const totalPages = Math.ceil(paginationProps.total / paginationProps.pageSize) || 1;
        const validPageNum = Math.max(1, Math.min(pageNum, totalPages));
        onChange(validPageNum, paginationProps.pageSize);
      } else {
        setPageInputValue(paginationProps.current?.toString() || '1');
      }
    }
  };

  const handlePrevPage = () => {
    if (paginationProps.current > 1) {
      const newCurrent = paginationProps.current - 1;
      onChange(newCurrent, paginationProps.pageSize);
    }
  };

  
  const handleNextPage = () => {
    const totalPages = Math.ceil(paginationProps.total / paginationProps.pageSize) || 1;
    if (paginationProps.current < totalPages) {
      const newCurrent = paginationProps.current + 1;
      onChange(newCurrent, paginationProps.pageSize);
    }
  };

  
  const handlePageSizeChange = (e) => {
    console.log('handlePageSizeChange', e);
    const newPageSize = Number(e);
    onChange(1, newPageSize);
  };

  const totalPages = Math.ceil(paginationProps.total / paginationProps.pageSize);

  return (
    <div className="pagination-container">
      <span className='totals-pag'>Total {paginationProps.total} items</span>
      <div className="custom-pagination">
        <div 
          className={paginationProps.current === 1?"pagination-btn-disable":"pagination-btn-sel"}
          onClick={handlePrevPage}
        >
          &lt;Previous
        </div>
        
        <div 
          className={paginationProps.current >= totalPages?"pagination-btn-disable":"pagination-btn-sel"}
          onClick={handleNextPage}
          disabled={paginationProps.current >= totalPages}
        >
          Next&gt;
        </div>
        
        <div className="page-size-selector-sel">
          <Select 
            value={paginationProps.pageSize} 
            onChange={(e)=>handlePageSizeChange(e)}
            className="page-size-select"
          >
            {pageSizeOptions.map(option => (
              <Option className='slect-page-option' key={option.value} value={option.value}>{option.label}</Option>
            ))}
          </Select>
        </div>
        
        <div className="page-jumper">
          <span>Go to</span>
          <input 
            type="text" 
            value={pageInputValue}
            onChange={handleInputChange}
            onKeyPress={handleKeyPress}
            className="page-input"
          />
          <span>/ {totalPages}</span>
        </div>
      </div>
    </div>
  );
};

export default PaginationComponent;